
import React, { useState } from 'react';
import { FaRegCreditCard } from 'react-icons/fa';
import Cards from 'react-credit-cards-2';
import 'react-credit-cards/es/styles-compiled.css';
import { Card, Button } from "react-bootstrap";
import InputMask from 'react-input-mask';
import '@fortawesome/fontawesome-free/css/all.min.css';

const PaymentMethod = () => {
  const [savedCards, setSavedCards] = useState([]);
  const [showAddCard, setShowAddCard] = useState(false); // To toggle the add card form

  const handleAddCardModalShow = () => {
    setShowAddCard(true); // Show the add card form
  };
  const [cardDetails, setCardDetails] = useState({
    number: '',
    expiry: '',
    name: '',
    focus: '',
    issuer: '', // New field for card issuer
  });

  const [errors, setErrors] = useState({
    number: '',
    expiry: '',
    name: '',
  });

  const handleInputChange = (evt) => {
    const { name, value } = evt.target;
    setCardDetails((prev) => ({ ...prev, [name]: value }));

    // Custom logic to detect RuPay cards
    if (name === 'number') {
      const issuer = detectCardIssuer(value);
      setCardDetails((prev) => ({ ...prev, issuer })); // Update the issuer field
    }

    // Clear error for the field being edited
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleInputFocus = (evt) => {
    setCardDetails((prev) => ({ ...prev, focus: evt.target.name }));
  };

  const detectCardIssuer = (number) => {
    if (/^508/.test(number) || /^606/.test(number) || /^652/.test(number) || /^653/.test(number)) {
      return 'rupay';
    }
    // Add additional checks for other card types if needed
    return ''; // Default empty issuer
  };

  const validateForm = () => {
    const newErrors = {};
    const cardNumberWithoutSpaces = cardDetails.number.replace(/\s+/g, '');
    // Card Number Validation
    if (!cardDetails.number) {
      newErrors.number = 'Card Number is required.';
    } else if (!/^\d{16,19}$/.test(cardNumberWithoutSpaces)) {
      newErrors.number = 'Card Number must be 16 or 19 digits.';
    }

    // Cardholder Name Validation
    if (!cardDetails.name) {
      newErrors.name = 'Cardholder Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(cardDetails.name)) {
      newErrors.name = 'Cardholder Name must contain only letters and spaces.';
    }

    // Expiry Date Validation
    if (!cardDetails.expiry) {
      newErrors.expiry = 'Expiry Date is required.';
    } else if (!/^(0[1-9]|1[0-2])\/?([0-9]{2})$/.test(cardDetails.expiry)) {
      newErrors.expiry = 'Expiry Date must be in MM/YY format.';
    } else {
      const [month, year] = cardDetails.expiry.split('/').map(Number);
      const today = new Date();
      const currentYear = today.getFullYear() % 100;
      const currentMonth = today.getMonth() + 1;

      if (year < currentYear || (year === currentYear && month < currentMonth)) {
        newErrors.expiry = 'Expiry Date cannot be in the past.';
      }
    }

    return newErrors;
  };

  const handleSaveCard = () => {
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setSavedCards([...savedCards, cardDetails]);
    setCardDetails({
      number: '',
      expiry: '',
      name: '',
      focus: '',
      issuer: '',
    });
    setShowAddCard(false);
  };

  const handleCancel = () => {
    setCardDetails({
      number: '',
      expiry: '',
      name: '',
      focus: '',
      issuer: '',
    });
    setShowAddCard(false);
  };

  const handleRemoveCard = (index) => {
    const updatedCards = savedCards.filter((_, i) => i !== index);
    setSavedCards(updatedCards);
  };

  return (
    <div>
      <Card>
        <Card.Header>
          <h3>Your Payment Methods</h3>
        </Card.Header>
        <Card.Body>

          <div className="rbi-guidelines-message mt-5 text-center">
            <h5>
              As per RBI guidelines, we are not currently saving payment methods.
            </h5>
          </div>
          {/* <div className="saved-cards mt-5">
            {savedCards.length > 0 ? (
              <>
                <h5>Your Saved Cards:</h5>
                <div className="d-flex flex-wrap">
                  {savedCards.map((card, index) => (
                    <div key={index} className="m-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h4>Card {index + 1}</h4>
                        <Button variant="danger" onClick={() => handleRemoveCard(index)}>
                          Remove
                        </Button>
                      </div>
                      <Cards
                        number={card.number}
                        expiry={card.expiry}
                        name={card.name}
                        focused={card.focus}
                        issuer={card.issuer} 
                      />
                    </div>
                  ))}
                </div>
              </>
            ) : null}

            {!showAddCard && (
              <div className="add-card-container mt-4" onClick={handleAddCardModalShow}>
                <Card className="text-center p-4" style={{ border: '1px dashed #d3d3d3', width: '250px', cursor: 'pointer' }}>
                  <FaRegCreditCard size={48} color="#7b72ef" />
                  <div className="mt-3">
                    <Button variant="link" className="text-decoration-none">
                      + Add new card
                    </Button>
                  </div>
                </Card>
              </div>
            )}

            
            {showAddCard && (
              <>
                <div className="container mt-4">
                  <div className="row">
                    <div className="col-12 text-center">
                      <h5>Add New Card</h5>
                    </div>
                    <div className="col-md-6">
                      <Card>
                        <Card.Body>
                          <Cards
                            number={cardDetails.number}
                            name={cardDetails.name}
                            expiry={cardDetails.expiry}
                            focused={cardDetails.focus}
                            issuer={cardDetails.issuer} 
                          />
                        </Card.Body>
                      </Card>
                    </div> */}

          {/* Column 2: Form */}
          {/* <div className="col-md-6 ">
                      <form >
                        <div className="form-group mb-3 ">
                          <InputMask
                            mask="9999 9999 9999 9999"
                            value={cardDetails.number}
                            name="number"
                            onChange={handleInputChange}
                            onFocus={handleInputFocus}
                          >
                            {(inputProps) => (
                              <input
                                {...inputProps}
                                type="text"
                                className="form-control"
                                placeholder="Card Number"
                              />
                            )}
                          </InputMask>
                          {errors.number && <small className="text-danger">{errors.number}</small>}
                        </div>

                        <div className="form-group mb-3">
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Cardholder Name"
                            value={cardDetails.name}
                            onChange={handleInputChange}
                            onFocus={handleInputFocus}
                          />
                          {errors.name && <small className="text-danger">{errors.name}</small>}
                        </div>

                        <div className="form-group mb-3">
                          <InputMask
                            mask="99/99"
                            value={cardDetails.expiry}
                            name="expiry"
                            onChange={handleInputChange}
                            onFocus={handleInputFocus}
                          >
                            {(inputProps) => (
                              <input
                                {...inputProps}
                                type="text"
                                className="form-control"
                                placeholder="Expiry Date (MM/YY)"
                              />
                            )}
                          </InputMask>
                          {errors.expiry && <small className="text-danger">{errors.expiry}</small>}
                        </div>

                        <div className="d-flex justify-content-between mt-4">
                          <Button variant="primary" onClick={handleSaveCard}>
                            Save Card
                          </Button>
                          <Button variant="secondary" onClick={handleCancel}>
                            Cancel
                          </Button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div> */}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PaymentMethod;

